
function setLeads(data){
    return{
        type : "SET_LEADS",
        payload : data
    }
}

export {  
    setLeads,
}